(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("numberkeyboard", [], factory);
	else if(typeof exports === 'object')
		exports["numberkeyboard"] = factory();
	else
		root["numberkeyboard"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 